// extracted by mini-css-extract-plugin
module.exports = {"container":"bottom_container__2UhZ2","links":"bottom_links__j7H10","ul":"bottom_ul__2u0FL","li":"bottom_li__18ocH","first":"bottom_first__1bl-f"};